export default "__VITE_ASSET__BSSRIAa7__"